export const CLEAN_TAX_AUTHORITIES = 'clean_tax_authorities';
export const SET_TAX_AUTHORITIES_LIST = 'tax_authorities_list';

export const SYNC_FAILED = 'update_sync_error';
export const SYNC_FINISHED = 'tax_authorities_sync_has_finished';
export const SYNC_INITIATED = 'tax_authorities_sync_was_initiated';
